import {epics as navigationEpics} from './react-modals/navigationEpic';

export const epics = [
  ...navigationEpics,
];



// WEBPACK FOOTER //
// ./src/js/core-utilities/epics.js